<div class="load-wrapp">
  <div class="load-3">
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
  </div>
</div>
